import { render, staticRenderFns } from "./ExtraPhoto.vue?vue&type=template&id=7a77fa2d&scoped=true"
import script from "./ExtraPhoto.vue?vue&type=script&lang=js"
export * from "./ExtraPhoto.vue?vue&type=script&lang=js"
import style0 from "./ExtraPhoto.vue?vue&type=style&index=0&id=7a77fa2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a77fa2d",
  null
  
)

export default component.exports